import { ExceptionReportToDisplay, OrderComment } from './exception-report';
import { FavoriteOrders } from './favorite-orders';

export interface Order {
	id: string;
	customerOrderNumber: string;
	customerOrderItemNumber: string;
	supplierOrderItemNumber: string;
	supplierOrderNumber: string;
	steelgrade: string;
	steelgradeDescription: string;
	steelgradeStandard: string;
	steelgradeStandardDescription: string;
	cdd: string;
	cddWeek?: string;
	customerArticleReference: string;
	thickness: number;
	width: number;
	length: number;
	thicknessString: string;
	widthString: string;
	lengthString: string;
	mill: string;
	millDescription: string;
	deliveryMode: string;
	deliveryModeDescription: string;
	shipTo: string;
	shipToDescription: string;
	orderCreationDate: string;
	endUser: string;
	endUserDescription: string;
	billTo: string;
	billToDescription: string;
	qualityControl: number;
	batchesNotDeliveredGross: number;
	batchesNotDeliveredNet: number;
	chemicalPassivation: string;
	chemicalPassivationDescription: string;
	certificate: string;
	certificateDescription: string;
	colorCategoryBottom: string;
	colorCategoryBottomDescription: string;
	colorCategoryTop: string;
	colorCategoryTopDescription: string;
	brandNamePaintTypeBottomSide: string;
	brandNamePaintTypeBottomSideDescription: string;
	brandNamePaintTypeTopSide: string;
	brandNamePaintTypeTopSideDescription: string;
	incoterm2: string;
	insideDiameterInmm: number;
	kindOfOil: string;
	kindOfOilDescription: string;
	colorFirstStrokeCross: string;
	colorFirstStrokeCrossDescription: string;
	pattern: string;
	patternDescription: string;
	protection: string;
	protectionDescription: string;
	materialNumber: string;
	ultrasonicTesting: string;
	ultrasonicTestingDescription: string;
	additionalTests: string;
	transportMode: string;
	transportModeDescription: string;
	incoterm: string;
	orderCreatorSys: string;
	choiceCode: string;
	choiceDescription: string;
	millOrderNumber: string;
	millOrderItemNumber: string;
	sfcc: string;
	sfccDescription: string;
	sfcCCountry: string;
	sfcCCountryDescription: string;
	coating: string;
	coatingDescription: string;
	colorBottomSide: string;
	orderItemStatus: string;
	orderItemStatusDescription: string;
	colorTopSide: string;
	itemReferenceSoldToParty: string;
	form: string;
	formDescription: string;
	productCategory: string;
	productCategoryDescription: string;
	productDescription: string;
	surface: string;
	surfaceDescription: string;
	orderWithCddGtRdd: string;
	salesQuarter: string;
	soldTo: string;
	soldToDescription: string;
	orderReason: string;
	orderReasonDescription: string;
	rdd: string;
	rddWeek: string;
	cddGtRdd: boolean;
	supplier: string;
	supplierDescription: string;
	orderManager: string;
	orderManagerDescription: string;
	previsionItem: string;
	previsionItemDescription: string;
	provisionalOrFirmItem: string;
	deliveryAddress: string;
	destinationByBoat: string;
	interpretationDeliveryDate: string;
	a2cProductReference: string;
	a2cProductReferenceVersion: string;
	ebusinessOrderNumber: string;
	ebusinessOrderItemNumber: string;
	customerTemplateReference: string;
	finalUse: string;
	finalUseDescription: string;
	grossQtyOrdered: number;
	grossQtyNotDelivered: number;
	grossQtyInProduction: number;
	grossInProductionPercentage: number;
	grossQtyBlocked: number;
	grossBlockedPercentage: number;
	grossQtyAvailableReadyToShip: number;
	grossAvailableReadyToShipPercentage: number;
	grossQtyAvailableInTransit: number;
	grossAvailableInTransitPercentage: number;
	grossQtyAvailableInConsignment: number;
	grossAvailableInConsignmentPercentage: number;
	grossQtyDelivered: number;
	grossDeliveredPercentage: number;
	grossQtyTotal: number;
	grossOrderWithMaterial: string;
	grossFirstBatchInStock: string;
	grossLastBatchInStock: string;

	netQtyOrdered: number;
	netQtyNotDelivered: number;
	netQtyInProduction: number;
	netInProductionPercentage: number;
	netQtyBlocked: number;
	netBlockedPercentage: number;
	netQtyAvailableReadyToShip: number;
	netAvailableReadyToShipPercentage: number;
	netQtyAvailableInTransit: number;
	netAvailableInTransitPercentage: number;
	netQtyAvailableInConsignment: number;
	netAvailableInConsignmentPercentage: number;
	netQtyDelivered: number;
	netDeliveredPercentage: number;
	netQtyTotal: number;
	netOrderWithMaterial: string;
	netFirstBatchInStock: string;
	netLastBatchInStock: string;
	favorite?: FavoriteOrders | undefined;
	isFavorite: boolean;
	supplierContractNumber: string;
	serviceLevelDescription: string;
	serviceRequestDescription: string;
	dataSheetTopSideDescription: string;
	colorTopSideDescription: string;
	colorBottomSideDescription: string;
	exceptionReport?: ExceptionReportToDisplay;
	comments?: OrderComment[];
	answers?: OrderComment[];
	recentComments?: OrderComment[];
	recentAnswers?: OrderComment[];
	trademarkNameTopSide: string;
	trademarkNameTopSideDescription: string;
	trademarkNameBottomSide: string;
	trademarkNameBottomSideDescription: string;
	serviceLevel: string;
	serviceRequest: string;
	organicCoatingTopSideStructure: string;
	dataSheetTopSide: string;
	xcarb: string;
	xcarbDescription: string;
	organicCoatingTopSideStructureDescription: string;
	organicCoatingBottomSideStructure: string;
	organicCoatingBottomSideStructureDescription: string;
	dataSheetBottomSide: string;
	dataSheetBottomSideDescription: string;
	qtyWipInsufficientMaterialBalance: number;
	qtyWipOpenNeeds: number;
	qtyWipHandedToPlanning: number;
	qtyWipPlannedCaster: number;
	qtyWipPrematerialOrdered: number;
	qtyWipSlab: number;
	qtyWipRollingStand: number;
	qtyWipHotRolled: number;
	qtyWipPickled: number;
	qtyWipAnnealed: number;
	qtyWipNormalizing: number;
	qtyWipMetallicCoated: number;
	qtyWipOrganicCoated: number;
	qtyWipSkinPass: number;
	qtyWipOxiCutting: number;
	qtyWipCuttingAndBeveling: number;
	qtyWipShotBlasting: number;
	qtyWipSlitting: number;
	qtyWipComposite: number;
	qtyWipColdRolled: number;
	qtyWipQualityInspectionUnpacked: number;
	qtyWipMaterialOnPackingLine: number;
	grossQuantityLandTransit: number;
	grossQuantityAtReshipper: number;
	grossQuantityOnVessel: number;
	grossQuantityOverseasTransit: number;
	grossQuantityInTransitToCustomer: number;
	netQuantityLandTransit: number;
	netQuantityAtReshipper: number;
	netQuantityOnVessel: number;
	netQuantityOverseasTransit: number;
	netQuantityInTransitToCustomer: number;
	totalThicknessOrgCoatingTop: number;
	totalThicknessOrgCoatingBottom: number;
	nominalGlossTopSide: number;
	nominalGlossBottomSide: number;
	grossQtyLandTransit: number;
	grossQtyAtReshipper: number;
	grossQtyOnVessel: number;
	grossQtyOverseasTransit: number;
	grossQtyInTransitToCustomer: number;
	netQtyLandTransit: number;
	netQtyAtReshipper: number;
	netQtyOnVessel: number;
	netQtyOverseasTransit: number;
	netQtyInTransitToCustomer: number;
	supplierRFQNumber: string;
	supplierRFQItemNumber: string;
	customerOrderNumberWithoutItem: string;
	orderCreatorMan: string;
	choice: string;
	incotermDescription: string;
	interpretationDeliveryDateDescription: string;
	stockAlert: string;
	grossStockAlert: string;
	netStockAlert: string;
}

export type FieldOfOrder = keyof Order;

export const orderCardFields = <const> [
	'orderItemStatus',
	'cddWeek',
	'steelgrade',
	'steelgradeDescription',
	'customerArticleReference',
	'customerOrderNumber',
	'customerOrderItemNumber',
	'supplierOrderNumber',
	'supplierOrderItemNumber',
	'thickness',
	'width',
	'length',
	'deliveryAddress',
	'transportMode',
	'incoterm',
	'incoterm2',
	'destinationByBoat',
	'deliveryMode',
	'millDescription',
	'orderCreationDate',
	'orderReason',
	'supplierDescription',
	'orderManager',
	'orderManagerDescription',
	'salesQuarter',
	'previsionItem',
	'provisionalOrFirmItem',
	'itemReferenceSoldToParty',
	'ebusinessOrderNumber',
	'millOrderNumber',
	'millOrderItemNumber',
	'soldToDescription',
	'shipToDescription',
	'endUserDescription',
	'billToDescription',
	'rddWeek',
	'interpretationDeliveryDate',
	'choiceDescription',
	'productCategory',
	'productDescription',
	'customerTemplateReference',
	'transportModeDescription',
	'grossQtyOrdered',
	'grossQtyInProduction',
	'grossQtyAvailableReadyToShip',
	'grossQtyAvailableInTransit',
	'grossQtyNotDelivered',
	'grossQtyDelivered',
	'grossFirstBatchInStock',
	'grossLastBatchInStock',
	'netQtyOrdered',
	'netQtyInProduction',
	'netQtyAvailableReadyToShip',
	'netQtyAvailableInTransit',
	'netQtyNotDelivered',
	'netQtyDelivered',
	'netFirstBatchInStock',
	'netLastBatchInStock',
	'grossQtyAvailableInConsignment',
	'netQtyAvailableInConsignment',
	'mill',
	'soldTo',
	'supplierContractNumber',
	'serviceLevel',
	'serviceLevelDescription',
	'serviceRequest',
	'serviceRequestDescription',
	'colorTopSide',
	'colorBottomSide',
	'dataSheetTopSide',
	'dataSheetTopSideDescription',
	'dataSheetBottomSide',
	'dataSheetBottomSideDescription',
	'organicCoatingTopSideStructure',
	'organicCoatingBottomSideStructure',
	'xcarb',
	'xcarbDescription',
	'supplierRFQNumber',
	'supplierRFQItemNumber',
	'stockAlert'
];

export const characteristicFields = <const> [
	'code',
	'description',
	'valueCode',
	'valueNum',
	'valueUnit',
	'valueDescription'
];

export interface AggregateOrder {

	qtyOrdered: number;

	grossQtyNotDelivered: number;

	qtyInProduction: number;

	grossQtyBlocked: number;

	grossQtyAvailableReadyToShip: number;

	grossQtyAvailableInConsignment: number;

	grossQtyDelivered: number;

	grossQtyAvailableInTransit: number;

	netQtyBlocked: number;

	netQtyAvailableReadyToShip: number;

	netQtyAvailableInConsignment: number;

	netQtyNotDelivered: number;

	netQtyDelivered: number;

	netQtyAvailableInTransit: number;
}

// fields to align with the names in datacenter grid header
export interface TotalGridFields {

	grossQtyOrdered?: number;
	grossQtyInProduction?: number;
	netQtyBlocked?: number;
	netQtyAvailableReadyToShip?: number;
	netQtyAvailableInTransit?: number;
	netQtyAvailableInConsignment?: number;
	netQtyDelivered?: number;
	netQtyNotDelivered?: number;
	netQtyTotal?: number;
	grossQtyBlocked?: number;
	grossQtyAvailableReadyToShip?: number;
	grossQtyAvailableInTransit?: number;
	grossQtyAvailableInConsignment?: number;
	grossQtyDelivered?: number;
	grossQtyNotDelivered?: number;
	grossQtyTotal?: number;
	insideDiameterInmm?: number;
}
